export default "__VITE_ASSET__COR2M$C3__"